import { render, staticRenderFns } from "./ColorModuleTable.vue?vue&type=template&id=37045e38&scoped=true"
import script from "./ColorModuleTable.vue?vue&type=script&lang=ts"
export * from "./ColorModuleTable.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleTable.vue?vue&type=style&index=0&id=37045e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37045e38",
  null
  
)

export default component.exports